import { mobileShellFor } from "@ect/contracts";
export const MOBILE_BREAKPOINT_PX = 900;
/**
 * Adaptive shell decision (build plan §1.3): platform + viewport + role.
 * Tauri or a wide browser → desktop admin shell. Phones → admin or field shell by role.
 */
export function resolveShell(input) {
    if (input.platform === "tauri")
        return "desktop_admin";
    const isMobile = input.platform === "capacitor" || input.viewportWidth < MOBILE_BREAKPOINT_PX;
    if (!isMobile)
        return "desktop_admin";
    return mobileShellFor(input.role);
}
export function detectPlatform() {
    if (typeof window === "undefined")
        return "web";
    const w = window;
    if (w.__TAURI_INTERNALS__)
        return "tauri";
    if (w.Capacitor?.isNativePlatform?.())
        return "capacitor";
    return "web";
}
//# sourceMappingURL=shell.js.map